<template lang="html">
  <div class="timestamp">
    <div v-if="loading">
      <div class="gap-3x" />
      <Spinner />
      <div class="gap-3x" />
    </div>
    <div v-if="!loading">
      <div class="section-field no-border-top">
        <div v-if="isSuspendedVendor" class="suspended gray">
          <i class="si-icon-bold si-icon-text-5x si-warning_circle"></i>
          Your vendor account has been suspended
        </div>

        <div class="desktop-only flex-box vertically-centered gray">
          <div class="timestamp-column">
            <div class="descriptor bgap-4">Status</div>
            <div class="body-17">{{status}}</div>
            <div class="gap-1x" />
            <div
              class="body-16-medium purple cursor-pointer-hover-underline"
              @click="() => $emit('unpublish')"
              v-if="publishedAt && !isSuspendedVendor"
            >
              Unpublish this product
            </div>
          </div>
          <div class="timestamp-column">
            <div class="descriptor bgap-4">Last Saved</div>
            <div class="body-17">{{formattedUpdatedAt}}</div>
          </div>
          <div class="last-published-coulumn">
            <div class="descriptor bgap-4">Last Published</div>
            <div class="body-17">{{formattedPublishedAt}}</div>
          </div>
          <div class="">
            <div
              class="body-16-medium purple cursor-pointer-hover-underline"
              @click="() => $emit('destroy')"
            >
              Delete Product
            </div>
          </div>
        </div>

        <div class="mobile-only">
          <div class="flex-box gray">
            <div class="flex-1">
              <div class="descriptor bgap-4">Status</div>
              <div class="body-17">{{status}}</div>
              <div
                class="body-16-medium purple cursor-pointer-hover-underline"
                @click="() => $emit('unpublish')"
                v-if="publishedAt && !isSuspendedVendor"
              >
                Unpublish this product
              </div>
            </div>

            <div class="">
              <div
                class="body-16-medium purple cursor-pointer-hover-underline"
                @click="() => $emit('destroy')"
              >
                Delete Product
              </div>
            </div>
          </div>
          <div class="gap-3x" />
          <div class="descriptor bgap-4">Last Saved</div>
          <div class="body-17">{{formattedUpdatedAt}}</div>
          <div class="gap-3x" />
          <div class="descriptor bgap-4">Last Published</div>
          <div class="body-17">{{formattedPublishedAt}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import Spinner from 'src/components/common/Spinner.vue'

export default {
  components: { Spinner },
  props: ['publishedAt', 'updatedAt', 'loading', 'status', 'isSuspendedVendor'],
  computed: {
    formattedUpdatedAt() {
      if(!this.updatedAt) return '—'
      return moment(this.updatedAt).format('LLL')
    },
    formattedPublishedAt() {
      if(!this.publishedAt) return '—'
      return moment(this.publishedAt).format('LLL')
    },
  }
}
</script>

<style lang="scss" scoped>
.timestamp {
  .timestamp-column {
    margin-right: 160px;
  }

  .suspended {
    padding-top: 12px;
  }

  .last-published-coulumn {
    flex-grow: 1;
  }

  @media screen and (max-width: 768px) {
    .timestamp-column {
      margin-right: 0;
    }

    .section-field {
      padding: 24px 0;
    }
  }
}
</style>
